
const QRCode = ({qr, vertical=false, infoTip ='Scan the QR code to find your nearest branch for detailed information on Early Bird Benefits.' }) => {
    const flexDir = vertical ? 'column-reverse': 'row'
    return(
         <div
            className="d-flex align-items-end"
            style={{ borderRadius: "10px", maxWidth: "400px", display: 'flex', flexDirection:flexDir, gap: '0.5rem', height: '150px' }}
          >
            <span
              className="p-2 fw-bold"
              style={{
                fontSize: "12px",
                maxWidth: "160px",
                textAlign: vertical ? "center" : "end",
                alignSelf: vertical ? "center" : "end",
              }}
            >
              {infoTip}
            </span>
            <img
              className={`img-fluid w-75 h-75 bottom-0 ${vertical ? 'align-self-center' : ''}`}
              src={qr}
              alt="qr-code"
            />
          </div>
    )
}
export default QRCode